/*
 * Vintage Fur Mania — shared newsletter engine
 * ---------------------------------------------------------------------------
 * WHY THIS FILE NO LONGER POSTS TO SHOPIFY BY FETCH
 *
 * This store has Shopify bot protection enabled on customer forms. Any
 * hand-built fetch to /contact is rejected:
 *     400  "Missing CAPTCHA token"
 * The token is injected by Shopify only into forms rendered with Liquid's
 * {% form 'customer' %} tag, so a JS-constructed request can never satisfy it.
 * Confirmed directly against the storefront, not assumed.
 *
 * So the popup and the section now render a real {% form 'customer' %} and let
 * it submit natively. Shopify processes it and returns to the page with
 * ?customer_posted=true, at which point we reopen in the success state.
 *
 * If MAILCHIMP_POST_URL is set, we use Mailchimp instead: it is JSONP, never
 * touches Shopify, has no CAPTCHA, and needs no page reload. That is the
 * better experience, and adding the URL below switches to it automatically.
 */
(function () {
  'use strict';

  /* =========================================================================
     MAILCHIMP — optional. Set this and the forms stop reloading the page.
       Mailchimp -> Audience -> Signup forms -> Signup form URL
       It looks like:
         https://vintagefurmania.us2.list-manage.com/subscribe/post?u=AAA&id=BBB
       Change /subscribe/post to /subscribe/post-json and paste it below.
     ========================================================================= */
  var MAILCHIMP_POST_URL = ''; // <-- PASTE post-json URL HERE (optional)
  var MAILCHIMP_BOT_FIELD = ''; // <-- optional, the b_<u>_<id> field name

  var STORAGE_KEY = 'vfm:newsletter';
  var PENDING_KEY = 'vfm:pending';
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i;

  function isValidEmail(e) {
    return EMAIL_RE.test(String(e || '').trim());
  }

  /* ---- Mailchimp (JSONP) -------------------------------------------------- */
  function subscribeMailchimp(email) {
    return new Promise(function (resolve) {
      if (!MAILCHIMP_POST_URL) {
        resolve({ ok: false, skipped: true, message: '' });
        return;
      }

      var cb = 'vfmMc' + Date.now() + Math.floor(Math.random() * 1e4);
      var script = document.createElement('script');
      var timer = window.setTimeout(function () {
        done({ result: 'error', msg: 'timeout' });
      }, 8000);

      function cleanup() {
        window.clearTimeout(timer);
        try {
          delete window[cb];
        } catch (e) {
          window[cb] = undefined;
        }
        if (script.parentNode) script.parentNode.removeChild(script);
      }

      function done(data) {
        cleanup();
        var msg = String((data && data.msg) || '');
        var already = /already subscribed|already a list member/i.test(msg);
        if ((data && data.result === 'success') || already) {
          resolve({ ok: true, message: '' });
          return;
        }
        if (msg && !/timeout|network/i.test(msg)) {
          resolve({
            ok: false,
            message: msg.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim()
          });
          return;
        }
        resolve({ ok: false, message: '' }); // transport problem, caller falls back
      }

      window[cb] = done;

      var url =
        MAILCHIMP_POST_URL +
        (MAILCHIMP_POST_URL.indexOf('?') > -1 ? '&' : '?') +
        'EMAIL=' + encodeURIComponent(email) + '&c=' + cb;
      if (MAILCHIMP_BOT_FIELD) url += '&' + encodeURIComponent(MAILCHIMP_BOT_FIELD) + '=';

      script.src = url;
      script.async = true;
      script.onerror = function () {
        done({ result: 'error', msg: 'network' });
      };
      document.head.appendChild(script);
    });
  }

  /* ---- Clipboard ---------------------------------------------------------- */
  function copy(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text).then(function () { return true; }, function () { return false; });
    }
    return new Promise(function (resolve) {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.top = '-9999px';
      document.body.appendChild(ta);
      ta.select();
      var ok = false;
      try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
      document.body.removeChild(ta);
      resolve(ok);
    });
  }

  /* ---- Persistence -------------------------------------------------------- */
  var store = {
    read: function () {
      try {
        var raw = window.localStorage.getItem(STORAGE_KEY);
        if (raw) return JSON.parse(raw);
      } catch (e) { /* storage blocked */ }
      var m = document.cookie.match(/(?:^|;\s*)vfm_newsletter=([^;]*)/);
      if (m) { try { return JSON.parse(decodeURIComponent(m[1])); } catch (e) { return null; } }
      return null;
    },
    write: function (value, days) {
      var payload = JSON.stringify(value);
      try { window.localStorage.setItem(STORAGE_KEY, payload); } catch (e) { /* cookie below */ }
      var expires = new Date(Date.now() + days * 864e5).toUTCString();
      document.cookie = 'vfm_newsletter=' + encodeURIComponent(payload) + ';expires=' + expires + ';path=/;SameSite=Lax';
    },
    clear: function () {
      try { window.localStorage.removeItem(STORAGE_KEY); } catch (e) { /* noop */ }
      document.cookie = 'vfm_newsletter=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/';
    }
  };

  /* ---- Which surface submitted, across the native reload ------------------ */
  function markPending(which) {
    try { window.sessionStorage.setItem(PENDING_KEY, which); } catch (e) { /* noop */ }
  }

  function takePending() {
    var v = null;
    try {
      v = window.sessionStorage.getItem(PENDING_KEY);
      window.sessionStorage.removeItem(PENDING_KEY);
    } catch (e) { /* noop */ }
    return v;
  }

  function justPosted() {
    return /[?&]customer_posted=true/.test(window.location.search);
  }

  window.VFMNewsletterAPI = {
    hasMailchimp: !!MAILCHIMP_POST_URL,
    isValidEmail: isValidEmail,
    subscribeMailchimp: subscribeMailchimp,
    copy: copy,
    store: store,
    markPending: markPending,
    takePending: takePending,
    justPosted: justPosted
  };
})();
